interface SectionDividerProps {
    compact?: boolean;
    boundary?: boolean;
    topAligned?: boolean;
    heroFade?: boolean;
}

export default function SectionDivider({
    compact = false,
    boundary = false,
    topAligned = false,
    heroFade = false,
}: SectionDividerProps) {
    return (
        <div
            className={`laser-divider${compact ? ' laser-divider-compact' : ''}${boundary ? ' laser-divider-boundary' : ''}${topAligned ? ' laser-divider-top-aligned' : ''}${heroFade ? ' laser-divider-hero-fade' : ''}`}
            data-divider-reveal
            aria-hidden
        />
    );
}
